<script lang="ts">
  import { theme, type ThemePreference } from './theme.svelte';

  /* Tri-state, not a boolean: "system" is the default and a real option.
   * A radio group — not three buttons — so arrow keys work and screen readers
   * announce "1 of 3" without any ARIA. */
  const options: { value: ThemePreference; label: string }[] = [
    { value: 'system', label: 'System' },
    { value: 'light', label: 'Lys' },
    { value: 'dark', label: 'Mørk' },
  ];
</script>

<fieldset class="theme-toggle">
  <legend class="visually-hidden">Fargetema</legend>
  {#each options as option (option.value)}
    <label>
      <input
        type="radio"
        name="theme"
        value={option.value}
        bind:group={theme.preference}
      />
      <span>{option.label}</span>
    </label>
  {/each}
</fieldset>

<style>
  .theme-toggle {
    display: flex;
    gap: var(--space-1);
    padding: var(--space-1);
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius-pill);
    background: var(--surface-raised);
  }

  label {
    display: grid;
    border-radius: var(--radius-pill);
    font-size: var(--text-sm);
    font-weight: var(--nrk-sans-weight-medium);
    color: var(--text-muted);
    cursor: pointer;

    /* The radio is the accessible control; the text is the visible one.
     * Stacking them in one grid cell keeps the input focusable and hit-
     * testable without positioning tricks. */
    & > * {
      grid-area: 1 / 1;
    }

    &:hover {
      color: var(--text);
    }
  }

  input {
    appearance: none;
    margin: 0;
    border-radius: inherit;
    cursor: pointer;
  }

  span {
    padding: var(--space-1) var(--space-3);
  }

  label:has(:checked) {
    background: var(--surface);
    color: var(--text);
    box-shadow: var(--shadow-sm);
  }
</style>
